export default __webpack_public_path__ + "static/media/icons8-pin-48.32b25de6.svg";